
export const JOB_TITLES = [  
  { id: 1, label: "Admin Officer", value: "admin_officer" },
  { id: 2, label: "Admin Officer, Kano", value: "admin_officer_kano" },
  { id: 3, label: "Administrative Assistant /Comms Assistant", value: "admin_asst_comms" },
  { id: 4, label: "Analyst", value: "analyst" },
  { id: 5, label: "ART Advisor", value: "art_advisor" },
  { id: 6, label: "Assistant", value: "assistant" },
  { id: 7, label: "Associate Director", value: "associate_director" },
  { id: 8, label: "Chief Party", value: "chief_party" },
  { id: 9, label: "Communications Specialist", value: "comm_specialist" },
  { id: 10, label: "Country Security Manager", value: "country_security_mgr" },
  { id: 11, label: "Deputy Chief of Party/Technical Director", value: "dcop_tech_dir" },
  { id: 12, label: "Director HSS & Advisory Services", value: "dir_hss_adv" },
  { id: 13, label: "Director MEL ACE3", value: "dir_mel_ace3" },
  { id: 14, label: "Director of Compliance", value: "dir_compliance" },
  { id: 15, label: "Director of Finance", value: "dir_finance" },
  { id: 16, label: "Director of Health Informatics", value: "dir_health_informatics" },
  { id: 17, label: "Driver", value: "driver" },
  { id: 18, label: "Finance & Admin Officer", value: "finance_admin_officer" },
  { id: 19, label: "Finance Manager", value: "finance_mgr" },
  { id: 20, label: "Finance Officer", value: "finance_officer" },
  { id: 21, label: "Finance Specialist", value: "finance_specialist" },
  { id: 22, label: "Grants & Compliance Officer", value: "grants_compliance_officer" },
  { id: 23, label: "Grants and Compliance Officer", value: "grants_compliance_officer_alt" },
  { id: 24, label: "HR Officer", value: "hr_officer" },
  { id: 25, label: "HTS Advisor", value: "hts_advisor" },
  { id: 26, label: "Head of Logistics", value: "head_logistics" },
  { id: 27, label: "Health Informatics Officer", value: "health_info_officer" },
  { id: 28, label: "Health Systems Strengthening (HSS) Advisor", value: "hss_advisor" },
  { id: 29, label: "IT Specialist", value: "it_specialist" },
  { id: 30, label: "Laboratory Advisor", value: "lab_advisor" },
  { id: 31, label: "Laboratory Services Technical Advisor Sokoto", value: "lab_tech_sokoto" },
  { id: 32, label: "Lead Advisor, Health System Strengthening/Program Optimization", value: "lead_adv_hss_opt" },
  { id: 33, label: "Lead HIV Testing Service Advisor", value: "lead_hts_advisor" },
  { id: 34, label: "Logistics Officer", value: "logistics_officer" },
  { id: 35, label: "MEL Advisor", value: "mel_advisor" },
  { id: 36, label: "MERL Advisor", value: "merl_advisor" },
  { id: 37, label: "Monitoring Evaluation and Learning Advisor", value: "mel_advisor_long" },
  { id: 38, label: "Partner/COO", value: "partner_coo" },
  { id: 39, label: "PMTCT Advisor", value: "pmtct_advisor" },
  { id: 40, label: "PMTCT Officer", value: "pmtct_officer" },
  { id: 41, label: "Principal Technical Officer", value: "principal_tech_officer" },
  { id: 42, label: "Procurement Manager", value: "procurement_mgr" },
  { id: 43, label: "Program Associate", value: "program_associate" },
  { id: 44, label: "Program Manager", value: "program_mgr" },
  { id: 45, label: "Programs Officer", value: "programs_officer" },
  { id: 46, label: "Public Financial Management (PFM)", value: "pfm_mgr" },
  { id: 47, label: "Senior (Lead), Laboratory and Supply Chain", value: "sr_lab_supply_chain" },
  { id: 48, label: "Senior Analyst", value: "sr_analyst" },
  { id: 49, label: "Senior HR Manager", value: "sr_hr_mgr" },
  { id: 50, label: "Senior Technical Officer", value: "sr_tech_officer" },
  { id: 51, label: "Sokoto State Team Lead", value: "stl_sokoto" },
  { id: 52, label: "State Team Lead", value: "stl_general" },
  { id: 53, label: "STL", value: "stl_abbr" },
  { id: 54, label: "Supply Chain Advisor", value: "supply_chain_adv" },
  { id: 55, label: "Technical Director", value: "tech_director" },
  { id: 56, label: "Technical Officer HSS", value: "tech_officer_hss" },
  { id: 57, label: "Technical Officer SANHDEF", value: "tech_officer_sanhdef" },
  { id: 58, label: "Transport and Logistic Assistant", value: "transport_logistics_asst" },
  { id: 59, label: "Transport and Logistics Officer", value: "transport_logistics_officer" },
  { id: 60, label: "Ag-Chief Executive Officer", value: "ag_ceo" },
  { id: 61, label: "IT Manager", value: "it_manager" }
];